// extracted by mini-css-extract-plugin
export var formContainer = "_f3-0";
export var message = "_f3-1";